<template>
  <div class="user-table">
    <b-table
      id="user-tablearea"
      striped
      hover
      foot-clone
      stacked="md"
      head-variant="light"
      primary-key="id"
      :items="state.list"
      :fields="fields"
      :sort-by="state.sortBy"
      :sort-desc="state.sortDesc"
      no-local-sorting
      @sort-changed="sortChanged"
    >
      <template #cell(actions)="data">
        <b-button :to="'edit/' + data.item.id" variant="primary">編集</b-button>
        <span v-if="data.item.id !== auth.user_id">
          <b-button @click="onDelete(data.item.id)" variant="danger">削除</b-button>
          <b-button @click="password(data.item.id)" variant="secondary">招待する</b-button>
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'UserTable',

  computed: {
    ...mapState({ state: 'users', auth: 'auth' }),
  },

  mounted() {
    this.$store.dispatch('users/searchList', this.state);
  },

  data() {
    return {
      fields: [
        { key: 'id', label: 'ID', sortable: true, isRowHeader: true, variant: 'light' },
        { key: 'company', label: '会社名', sortable: true },
        { key: 'name', label: '名前', sortable: true },
        { key: 'email', label: 'メールアドレス', sortable: true },
        { key: 'actions', label: '操作' },
      ],
    };
  },

  methods: {
    onDelete(id) {
      this.$utils.confirm('ユーザー削除', '削除してよろしいですか？', () => {
        this.$store.dispatch('users/deleteItem', id);
      });
    },

    password(id) {
      this.$utils.confirm('ユーザー招待', 'ユーザー招待メールを送信します', () => {
        this.$store.dispatch('users/code', id);
      });
    },

    sortChanged(evt) {
      this.$store.dispatch('users/searchList', Object.assign({}, this.state, {
        sortBy: evt.sortBy,
        sortDesc: evt.sortDesc,
      }));
    },
  },
};
</script>

<style scoped>
</style>
